export default __webpack_public_path__ + "static/media/video.fff47893.svg";